import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/styles";
import { FilterBar, SelectFilterBar } from "../infopage/detailpage";
import { testNames, fullGrade, testNameList, simpleFullGrade } from "./config";
import StudentGradeDetailDialogButton from "./StudentGradeDetailDialogButton";
import TestDetailDialogButton from "./TestDetailDialogButton";
const useStyles = makeStyles(theme => ({
  table: {
    width: "100%"
  },
  tableHead: {
    backgroundColor: theme.palette.secondary.light
  },
  tableCell: {
    color: theme.palette.common.white
  },

  tableHeadCell: {
    minWidth: "100px"
  }
}));

//使用文献内容过滤
function useFilter(initValue) {
  const [filterValue, setFilterValue] = useState(initValue);

  const handleChange = name => event => {
    setFilterValue({ ...filterValue, [name]: event.target.value });
  };

  return { filterValue, handleChange };
}

const objectArrayFilter = (objectArray, filterValue) => {
  const filterFields = Object.keys(filterValue);
  let objectFiltered = [...objectArray];
  for (let index = 0; index < filterFields.length; index++) {
    const filterField = filterFields[index];

    if (filterValue[filterField] !== "" && objectFiltered.length > 0) {
      objectFiltered = objectFiltered.filter(object => {
        return (
          //String 使得数字成绩也可被过滤
          String(object[filterField]).indexOf(filterValue[filterField]) !== -1
        );
      });
    }
  }
  return objectFiltered;
};

//Main Component
function GradeList(props) {
  const classes = useStyles();
  //filterUserName是否过滤学生姓名
  const { gradeData, filterUserName, averageGrade } = props;
  const { filterValue, handleChange } = useFilter({
    test_type: "",
    user_name: "",
    grade: ""
  });
  const gradesFiltered = objectArrayFilter(gradeData, filterValue);

  //定义表头及是否过滤
  const tableHeadTitle = [
    { columnField: "test_type", columnName: "实验名称", selectFilter: true },
    { columnField: "grade", columnName: "实验成绩", filtered: true },
    {
      columnField: "user_name",
      columnName: "实验人",
      filtered: filterUserName
    },
    // { columnField: "created", columnName: "实验日期" },
    { columnField: "time_cost", columnName: "实验耗时/查看试卷" }
  ];

  return (
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow>
          {tableHeadTitle.map(
            ({ columnField, columnName, filtered, selectFilter }) => (
              <TableCell
                align="left"
                className={classes.tableHeadCell}
                key={columnField}
              >
                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  className={classes.typography}
                >
                  {columnName}
                </Typography>

                {filtered && gradeData.length > 1 && (
                  <>
                    <br />
                    <FilterBar
                      value={filterValue[columnField]}
                      handleChange={handleChange(columnField)}
                    />
                  </>
                )}

                {selectFilter && gradeData.length > 1 && (
                  <>
                    <br />
                    <SelectFilterBar
                      categoryOptions={testNameList}
                      value={filterValue.test_type}
                      handleChange={handleChange("test_type")}
                      label="实验类型"
                      minWidth="200px"
                    />
                  </>
                )}
              </TableCell>
            )
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {gradesFiltered.map(gradeItem => {
          const {
            id,
            test_type,
            grade,
            time_cost,
            user,
            user_name,
            specification,
            created
          } = gradeItem;
          return (
            <TableRow key={id} hover>
              <TableCell component="th" scope="row">
                {test_type}
              </TableCell>
              <TableCell align="left">{grade}</TableCell>
              <TableCell align="left">
                <>
                  {filterUserName ? (
                    <StudentGradeDetailDialogButton
                      buttonText={user_name}
                      grades={gradeData}
                      UserId={user}
                      averageGrade={averageGrade}
                    />
                  ) : (
                    user_name
                  )}
                </>
              </TableCell>
              {/* <TableCell align="left">{created.slice(0, 10)}</TableCell> */}

              <TableCell align="left">
                {specification && Array.isArray(specification) ? (
                  <TestDetailDialogButton
                    specification={specification}
                    buttonText="查看试卷"
                  />
                ) : (
                  `${time_cost}分钟`
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

export default GradeList;
